/* eslint-disable react/jsx-key */

import React from 'react';
import { createIcon } from '@chakra-ui/icons';

export const GalleryIcon = createIcon({
  displayName: 'GalleryIcon',
  viewBox: '0 0 36 35',
  path: [
    <path
      d="M5.04175 8.75C5.04175 6.12667 7.16842 4 9.79175 4H26.2084C28.8317 4 30.9584 6.12667 30.9584 8.75V26.25C30.9584 28.8733 28.8317 31 26.2084 31H9.79175C7.16842 31 5.04175 28.8733 5.04175 26.25V8.75Z"
      stroke="black"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      d="M12.3335 14.5833C13.5351 14.5833 14.5002 13.6182 14.5002 12.4167C14.5002 11.2151 13.5351 10.25 12.3335 10.25C11.1319 10.25 10.1668 11.2151 10.1668 12.4167C10.1668 13.6182 11.1319 14.5833 12.3335 14.5833Z"
      stroke="black"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      d="M5.04175 24.7917L11.3751 18.4583C12.5918 17.2417 14.5418 17.2417 15.7584 18.4583L22.5418 25.25"
      stroke="black"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      d="M21.0835 23.7917L23.5418 21.3333C24.7584 20.1167 26.7084 20.1167 27.9251 21.3333L30.9584 24.375"
      stroke="black"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
  ],
});
